function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { mergeStyleSets, Text } from 'office-ui-fabric-react';
import { CommandBarButton } from '../CommandBar';
import { ImageWithLazyLoading } from '../ImageWithLazyLoading';
import { OverflowSet } from '../OverflowSet';
import { Stack } from '../Stack';
import { Tooltip } from '../Tooltip';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const mergeStackStyles = (baseStyles, overrideStyles) => _objectSpread(_objectSpread(_objectSpread({}, baseStyles), overrideStyles), {}, {
  root: _objectSpread(_objectSpread({}, baseStyles.root), overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.root)
});
export const ImageWithActions = _ref => {
  let {
    actionItems,
    overflowActionItems,
    styles,
    height = 100,
    width = 200,
    padding = 5,
    imageOriginalHeight,
    imageOriginalWidth,
    noImageMessage,
    src,
    actionButtonHeight = 25,
    iconFontSize = 12,
    iconStyles,
    baseDataId,
    onImageClick,
    renderDescription
  } = _ref;
  const actionButtonStyles = mergeStyleSets({
    root: {
      padding: 5,
      height: actionButtonHeight
    },
    menuIcon: {
      fontSize: iconFontSize,
      margin: 'auto'
    },
    icon: {
      fontSize: iconFontSize
    }
  }, iconStyles);
  const imageHeight = height - actionButtonHeight - 2 * padding;
  const imageWidth = width - 2 * padding;
  const defaultControlWrapperStyles = {
    root: {
      height,
      width,
      padding
    }
  };
  const interactiveStyles = {
    root: {
      cursor: 'pointer'
    }
  };
  const renderSizeLabel = () => /*#__PURE__*/_jsx(SizeLabel, {
    width: imageOriginalWidth,
    height: imageOriginalHeight,
    dataId: "".concat(baseDataId, "-size-label")
  });
  return /*#__PURE__*/_jsxs(Stack, {
    styles: mergeStackStyles(defaultControlWrapperStyles, styles),
    children: [/*#__PURE__*/_jsx(Stack, {
      onClick: onImageClick,
      styles: onImageClick && interactiveStyles,
      children: !src ? /*#__PURE__*/_jsx(NoImageMessage, {
        message: noImageMessage,
        height: imageHeight,
        width: imageWidth,
        dataId: "".concat(baseDataId, "-no-image-message")
      }) : /*#__PURE__*/_jsx(ImageWithLazyLoading, {
        src: src,
        height: imageHeight,
        width: imageWidth,
        dataId: "".concat(baseDataId, "-image")
      })
    }), /*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      horizontalAlign: "space-between",
      verticalAlign: "center",
      children: [/*#__PURE__*/_jsx(OverflowSet, {
        items: actionItems,
        overflowItems: overflowActionItems,
        onRenderItem: onRenderItem(actionButtonStyles),
        onRenderOverflowButton: onRenderOverflowButton(actionButtonStyles),
        vertical: false
      }), renderDescription ? renderDescription({
        renderSizeLabel,
        Label
      }) : renderSizeLabel]
    })]
  });
};
const NoImageMessage = _ref2 => {
  let {
    message,
    width,
    height,
    dataId
  } = _ref2;
  return /*#__PURE__*/_jsx(Text, {
    styles: {
      root: {
        height,
        width,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    },
    "data-id": dataId,
    children: message
  });
};
const SizeLabel = _ref3 => {
  let {
    width,
    height,
    dataId
  } = _ref3;
  return /*#__PURE__*/_jsxs(Label, {
    dataId: dataId,
    children: [width, " x ", height]
  });
};
const Label = _ref4 => {
  let {
    children,
    dataId
  } = _ref4;
  return /*#__PURE__*/_jsx(Text, {
    styles: {
      root: {
        fontSize: 12
      }
    },
    "data-id": dataId,
    children: children
  });
};
const onRenderItem = actionButtonStyles =>
// eslint-disable-next-line react/display-name
item => {
  return /*#__PURE__*/_jsx(Tooltip, {
    tooltipBody: /*#__PURE__*/_jsx(_Fragment, {
      children: item.title
    }),
    children: /*#__PURE__*/_jsx(CommandBarButton, {
      "aria-label": item.name,
      styles: actionButtonStyles,
      iconProps: {
        iconName: item.icon
      },
      onClick: item.onClick,
      href: item.href,
      target: item.target,
      disabled: item.disabled,
      "data-id": item.dataId
    })
  });
};
const onRenderOverflowButton = actionButtonStyles =>
// eslint-disable-next-line react/display-name
overflowItems => {
  return /*#__PURE__*/_jsx(Tooltip, {
    tooltipBody: /*#__PURE__*/_jsx(_Fragment, {
      children: "More actions"
    }),
    children: /*#__PURE__*/_jsx(CommandBarButton, {
      "aria-label": "Actions",
      styles: actionButtonStyles,
      menuIconProps: {
        iconName: 'More'
      },
      menuProps: {
        items: overflowItems || []
      }
    })
  });
};